module.exports = __webpack_public_path__ + "static/spotify-ddde0f91b9118fab1caa24e88b8dbc99.png";